import { useEffect, useMemo, useRef } from '@redneckz/uni-jsx/lib/hooks';
const SENSITIVITY_SCALE = 10;
export function useIntersectionObserver(observerCallback, { sensitivity, rootRef } = {}) {
    const ref = useRef(null);
    const observerOptions = useMemo(() => ({ threshold: sensitivityToThreshold(sensitivity), root: rootRef?.current }), [sensitivity, rootRef?.current]);
    useEffect(() => {
        if (!ref.current) {
            return undefined;
        }
        const intersectionObserver = new IntersectionObserver(observerCallback, observerOptions);
        intersectionObserver.observe(ref.current);
        return () => {
            intersectionObserver.disconnect();
        };
    }, [observerCallback, observerOptions]);
    return ref;
}
function sensitivityToThreshold(sensitivity = 0) {
    const thresholdsCount = Math.round(sensitivity * SENSITIVITY_SCALE);
    return Array.from({ length: thresholdsCount })
        .fill(0)
        .map((_, thi) => Math.min(thi / thresholdsCount), 1)
        .concat(1);
}
//# sourceMappingURL=useIntersectionObserver.js.map